import { IonRow } from '@ionic/react';
import styled from 'styled-components';

export const IonRowCardLine = styled(IonRow)`
  justify-content: center;
  height: 100%;
  align-items: center;
`;
